/**
 * @description
 * @author librajt
 * @date 2018-06-06
 */

import Api from '../../path';
import { fetchData, fetchDataSync } from '@umu/umu-fetch';

interface IInput {
    homework_id: number;
    page?: number;
    size?: number;
}

type IOutput = IUserInfo[];

export const getTimelineStatUserList = fetchDataSync((data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.TIMELINE_STAT_USER_LIST, data).then((res: IResponse<IOutput>) => {
        return res;
    });
});

interface IUserMedal {
    id: string;
    medal_type: string;
    medal_rank: string;
}

export interface IUser {
    student_id: string;
    name: string;
    avatar: string;
    user_growth_points: number;
    user_level: number;
    show_user_level: number;
    user_medal: IUserMedal;
}

export interface IAsyncOutput {
    list: IUser[];
    page_info: IPageInfo;
}

export const getTimelineStatUserListAsync = (data: IInput): Promise<IResponse<IAsyncOutput>> => {
    return fetchData(Api.TIMELINE_STAT_USER_LIST, data);
};
